/** P3b 条件选数据的纯函数：标签主导值 / 条件命中 / 均匀采样 / 实例统计（CJS，供后端测试 require） */

/** 某组权重分布（tags[group] = {值: 权重}）取权重最高值；无分布返回 null */
function dominantOf(tags, group) {
  const dist = tags && tags[group];
  if (!dist || typeof dist !== 'object') return null;
  let best = null;
  let bestW = -1;
  for (const [value, w] of Object.entries(dist)) {
    const weight = Number(w) || 0;
    if (weight > bestW) {
      bestW = weight;
      best = value;
    }
  }
  return best;
}

/** 值是否为该组的主导（权重 = 最大值；平局任一值都算命中） */
function hasDominant(tags, group, value) {
  const dist = tags && tags[group];
  if (!dist || typeof dist !== 'object') return false;
  const target = Number(dist[value]) || 0;
  if (target <= 0) return false;
  const max = Math.max(...Object.values(dist).map(w => Number(w) || 0));
  return target === max;
}

/** 标签条件命中：filters = [{group, value}]，空条件恒命中；标签未知（tags 空）不命中任何非空条件 */
function matchesTagFilters(tags, filters) {
  const list = (filters || []).filter(f => f && f.group && f.value);
  if (list.length === 0) return true;
  if (!tags || typeof tags !== 'object') return false;
  return list.every(f => hasDominant(tags, f.group, f.value));
}

/** 标注条件命中：批次内该类别实例数 ≥ minInstances（默认 1）；条件为空恒命中 */
function matchesLabelFilter(labelStats, cond) {
  const c = cond || {};
  if (!c.label) return true;
  const min = Number(c.minInstances) || 1;
  return (Number((labelStats || {})[c.label]) || 0) >= min;
}

/** 批次录制时间排序键：优先 _YYYYMMDD_HHMMSS，其次 _HHMMSS，都解析不出时按批次名 */
function batchSortKey(batch) {
  const s = String(batch || '');
  const full = /_(\d{8})_(\d{6})$/.exec(s);
  if (full) return full[1] + full[2];
  const time = /_(\d{6})$/.exec(s);
  if (time) return time[1];
  return s;
}

/** 从有序数组均匀取 n 个（首尾必取，round 取点）；n 为空或 ≥ 长度返回全量副本 */
function uniformPick(list, n) {
  const arr = [...(list || [])];
  const limit = Number(n);
  if (!limit || limit >= arr.length) return arr;
  const out = [];
  for (let i = 0; i < limit; i++) {
    const idx = limit === 1 ? 0 : Math.round((i * (arr.length - 1)) / (limit - 1));
    out.push(arr[idx]);
  }
  return out;
}

/** 均匀采样：按录制时间排序后均匀取 n 批（首尾必取，round 取点）；n 为空或 ≥ 总数返回全量 */
function uniformSample(batches, n) {
  const list = [...(batches || [])].sort((a, b) => {
    const ka = batchSortKey(a && a.batch);
    const kb = batchSortKey(b && b.batch);
    return ka < kb ? -1 : ka > kb ? 1 : 0;
  });
  return uniformPick(list, n);
}

/** 单批实例总数 */
function batchInstanceTotal(labelStats) {
  return Object.values(labelStats || {}).reduce((s, v) => s + (Number(v) || 0), 0);
}

/** 跨批次实例求和（结果预览用） */
function sumLabelStats(batches) {
  const out = {};
  for (const b of batches || []) {
    for (const [label, v] of Object.entries(b.label_stats || {})) {
      out[label] = (Number(out[label]) || 0) + (Number(v) || 0);
    }
  }
  return out;
}

/** top n 类别（实例数降序），用于批次行实例列与预览统计 */
function topLabels(labelStats, n) {
  const list = Object.entries(labelStats || {})
    .map(([label, v]) => [label, Number(v) || 0])
    .filter(([, v]) => v > 0)
    .sort((a, b) => b[1] - a[1]);
  return list.slice(0, n || list.length);
}

module.exports = {
  dominantOf,
  hasDominant,
  matchesTagFilters,
  matchesLabelFilter,
  batchSortKey,
  uniformPick,
  uniformSample,
  batchInstanceTotal,
  sumLabelStats,
  topLabels,
};
